import axios, {InternalAxiosRequestConfig} from "axios";
import {getJwtToken} from "./authenticationService";

const HOST = import.meta.env.VITE_APP_REST_API_ENDPOINT as string;
const REST_API_URL = `${HOST}/web-api/v1`;

const apiClient = axios.create({
    baseURL: REST_API_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

/**
 * Closure storing current user impersonation id
 */
export const userImpersonation = (() => {
    let userId: string | undefined = undefined;

    return {
        get: () => userId,
        set: (val: string | undefined) => {
            userId = val;
        },
    };
})();

apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        if (config.url !== "/register") {
            const token = await getJwtToken();

            if (token && config.headers !== undefined) {
                config.headers.Authorization = `Bearer ${token}`;
            }

            const userImpersonateId = userImpersonation.get();

            if (userImpersonateId !== undefined && config.headers !== undefined) {
                config.headers["impersonate-user"] = userImpersonateId;
            }
        }

        return config;
    },
    (error: Error) => {
        return Promise.reject(error);
    },
);

export default apiClient;
